var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer"},[_c('p',{staticClass:"timer__text"},[_vm._v(_vm._s(_vm.time))]),_c('Notification',{attrs:{"contact":_vm.notification.contact,"message":_vm.notification.message,"duration":4500}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }